export default class RelatorioFaturamentoCartaoFidelidadeInformacao {
  valor_faturamento_total_intervalo: string;
  valor_faturamento_total?: any;
  valor_ticket_medio: string;
  valor_ticket_medio_mes?: any;
  valor_faturamento_mes?: any;
  valor_faturamento_dia?: any;
  total_clientes: number;
  total_clientes_intervalo: number;
}
